/* eslint-disable react/no-danger */
import Modal from '@Modal';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateIsSuppliersListModalOpen } from '../../Lib/redux/slices/legalStatement';
import useGetExperimentName from '../../Hooks/useGetExperimentName/useGetExperimentName';

const SuppliersListModal = () => {
  const dispatch = useDispatch();
  const { isLegalStatementMounted, isSuppliersListModalOpen, suppliersModal } =
    useSelector((store) => store.legalStatement);

  const modalExperimentName = useGetExperimentName({
    componentName: 'SuppliersListModal',
  });

  if (suppliersModal === undefined || !isLegalStatementMounted) {
    return null;
  }

  const handleClose = () => {
    if (isSuppliersListModalOpen) {
      dispatch(
        updateIsSuppliersListModalOpen({
          isSuppliersListModalOpen: false,
        })
      );
    }
  };

  const supplierModalTextWithoutButton = suppliersModal.replace(
    // eslint-disable-next-line no-useless-escape
    /\<button.*\<\/button\>/,
    ''
  );

  return (
    <div data-testid="supplierListModalContainer">
      <Modal
        open={isSuppliersListModalOpen}
        onClose={handleClose}
        experimentName={modalExperimentName}
        dataTestId="suppliersListModal"
      >
        <div
          dangerouslySetInnerHTML={{ __html: supplierModalTextWithoutButton }}
        />
      </Modal>
    </div>
  );
};

export default SuppliersListModal;
